import "./Skills.css";
import { DICT } from "../../utils/dict";
import { useContext } from "react";
import { ContextLanguage } from "../../context/ContextLanguage";
import html from "../../assets/skills/html.png";
import css from "../../assets/skills/css.png";
import js from "../../assets/skills/js.png";
import react_ from "../../assets/skills/react.png";
import next from "../../assets/skills/nextjs.png";
import node from "../../assets/skills/nodejs.png";
import express from "../../assets/skills/express.png";
import tanStack from "../../assets/skills/tanstack.png";
import ts from "../../assets/skills/ts.png";
import git from "../../assets/skills/git.png";
import cypress from "../../assets/skills/cypress.png";
import redux from "../../assets/skills/redux.png";
import java from "../../assets/skills/java.png";
import mui from "../../assets/skills/mui.png";
import blockchain from "../../assets/skills/blockchain.png";
import solidity from "../../assets/skills/solidity.png";
import star from "../../assets/stars/star.svg";
import star_half from "../../assets/stars/star-half.svg";
import star_full from "../../assets/stars/star-full.svg";
import { stateType } from "../../context/ContextLanguage";

const Skills: () => JSX.Element = () => {
  const [lang] = useContext<stateType>(ContextLanguage);

  const skillStars = {
    js: 4.5,
    ts: 4.5,
    react: 4.5,
    next: 4.5,
    node: 3,
    express: 2,
    tanStack: 4,
    redux: 4,
    html: 4.5,
    css: 4.5,
    git: 4,
    cypress: 2.5,
    mui: 4,
    blockchain: 2,
    solidity: 1,
    java: 1,
  };

  const getStars: (starsQuantity: number) => JSX.Element[] = (
    starsQuantity: number,
  ) => {
    return new Array(5)
      .fill("")
      .map((x, index) => (
        <img
          src={
            index + 1 <= starsQuantity
              ? star_full
              : index < starsQuantity
                ? star_half
                : star
          }
          alt="star"
          key={index}
        />
      ));
  };

  return (
    <div className="skills component" id="skills">
      <div className="skills__title_cntr">
        <div className="horizontal_line horizontal_line_before skills__line"></div>
        <p className="skills__title title">{DICT[lang].navbarSkills}</p>
        <div className="horizontal_line horizontal_line_after skills__line"></div>
      </div>
      <div className="skills__content_cntr content">
        <div className="skills__tools__cntr">
          <div className="skills_tools_part">
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={js} alt="java script" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_js}</p>
              <div>{getStars(skillStars.js)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={ts} alt="type script" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_ts}</p>
              <div>{getStars(skillStars.ts)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={react_} alt="react_" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_react}</p>
              <div>{getStars(skillStars.react)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={next} alt="next" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_next}</p>
              <div>{getStars(skillStars.next)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={node} alt="node" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_node}</p>
              <div>{getStars(skillStars.node)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={express} alt="express" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_express}</p>
              <div>{getStars(skillStars.express)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={html} alt="html5" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_html}</p>
              <div>{getStars(skillStars.html)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={css} alt="css3" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_css}</p>
              <div>{getStars(skillStars.css)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={redux} alt="redux" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_redux}</p>
              <div>{getStars(skillStars.redux)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={mui} alt="mui" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_mui}</p>
              <div>{getStars(skillStars.mui)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={tanStack} alt="tanStack" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_tanStack}</p>
              <div>{getStars(skillStars.tanStack)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={cypress} alt="cypress" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_cypress}</p>
              <div>{getStars(skillStars.cypress)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={git} alt="git" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_git}</p>
              <div>{getStars(skillStars.git)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img
                  className="skills__img"
                  src={blockchain}
                  alt="blockchain"
                />
              </figure>
              <p className="skills__tool_desc">
                {DICT[lang].skills_blockchain}
              </p>
              <div>{getStars(skillStars.blockchain)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={solidity} alt="solidity" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_solidity}</p>
              <div>{getStars(skillStars.solidity)}</div>
            </div>
            <div className="skills__tool_cntr">
              <figure
                data-aos="zoom-in"
                data-aos-duration="1000"
                className="skills__tools__figure"
              >
                <img className="skills__img" src={java} alt="java" />
              </figure>
              <p className="skills__tool_desc">{DICT[lang].skills_java}</p>
              <div>{getStars(skillStars.java)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
